import { Outlet } from 'react-router-dom'
import UnavailabilityAlert from '../../components/Common/UnavailabilityAlert'
import { CurrentUserProvider } from '../../components/User/UserProvider'
import { CurrentHcsGuard } from '../../components/feature/hcs/CurrentHcsProvider/CurrentHcsGuard'
import { CurrentHcsProvider } from '../../components/feature/hcs/CurrentHcsProvider/CurrentHcsProvider'
import { ParseGuard } from '../../components/legacy/ParseGuard'

export const LoggedGuard = () => (
    <CurrentUserProvider>
        <CurrentHcsProvider>
            <CurrentHcsGuard>
                <ParseGuard>
                    <Outlet />
                </ParseGuard>
            </CurrentHcsGuard>
            <UnavailabilityAlert />
        </CurrentHcsProvider>
    </CurrentUserProvider>
)
